class PDP {
  constructor(productJson, selectedVariantJson) {
    this.productJson = productJson
    this.selectedVariantJson = selectedVariantJson
    this.variantButtons = document.querySelectorAll('.pdp_product_variant')
    this.variantSelects = document.querySelectorAll('.pdp_product_variant_select')
    this.salePriceElement = document.querySelector('.pdp_product_price-sale')
    this.regularPriceElement = document.querySelector('.pdp_product_price-regular')
    this.priceDiscountElement = document.querySelector('.pdp_product_price-discount')
    this.quantityButtons = document.querySelectorAll('.quantity_button')
    this.quantityInput = document.querySelector('.quantity_input')
    this.variantQuantityElements = document.querySelectorAll('.pdp_product_variant_quantities li')
    this.addToCartButton = document.querySelector('#pdp_add_to_cart')

    this.initiate()
  }

  initiate() {
    this.updateOptionsUI()
    this.updatePriceUI()
    this.variantButtons.forEach(button => {
      button.addEventListener('click', () => this.handleOptionClick(button))
    })
    this.getVariantsQuantities()
    this.quantityButtons.forEach(button => {
      button.addEventListener('click', () => this.handleQuantityChange(button))
    })
    this.variantSelects.forEach(select => {
      select.addEventListener('change', () => this.handleSelectChange(select))
    })
    this.addToCartButton.addEventListener('click', () => this.handleAddToCart())
  }

  getVariantsQuantities() {
    const quantities = {}
    this.variantQuantityElements.forEach(element => {
      const variantId = element.dataset.variantId
      const quantity = element.dataset.variantQuantity
      quantities[variantId] = quantity
    })
    this.quantities = quantities
  }

  resetButtons() {
    this.variantButtons.forEach(button => button.classList.remove('selected'))
  }

  resetQuantity() {
    this.quantityInput.value = 1
  }

  toggleLoading(status = false) {
    if (status) {
      this.addToCartButton.classList.add('loading')
      this.addToCartButton.disabled = true
      return 
    }

    this.addToCartButton.classList.remove('loading')
    this.addToCartButton.disabled = false
  }

  updateURL(variantId) {
    const url = new URL(window.location.href)
    url.searchParams.set('variant', variantId)
    window.history.pushState(null, '', url.toString())
  }

  parseMoney(money) {
    return new Intl.NumberFormat('sfb', {
      style: 'currency',
      currency: 'EUR',
    })
    .format(money / 100)
  }

  updateOptionsUI(variant = this.selectedVariantJson) {
    if (!variant) return
    this.updateURL(variant.id.toString())
    const selectedOptions = new Set(variant.options); // Faster lookup

    this.variantButtons.forEach(button => {
      if (selectedOptions.has(button.dataset.optionValue)) {
        button.classList.add('selected');
      }
    })
  }

  updatePriceUI(variant = this.selectedVariantJson) {
    if (!variant) return

    this.regularPriceElement.textContent = `${this.parseMoney(variant.price)}`
    if (variant.compare_at_price === null) {
      this.salePriceElement.classList.add('hidden')
      this.priceDiscountElement.classList.add('hidden')
    } else {
      this.salePriceElement.classList.remove('hidden')
      this.priceDiscountElement.classList.remove('hidden')
      const salePrice = variant.compare_at_price
      this.salePriceElement.textContent = `${this.parseMoney(salePrice)}`
      const discount = (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price
      this.priceDiscountElement.textContent = `-${discount.toFixed(1)}%`
    }
  }

  handleOptionClick(button) {
    const optionValue = button.dataset.optionValue
    const optionPosition = parseInt(button.dataset.optionPosition, 10)
    const currentOptions = [...this.selectedVariantJson.options]
    currentOptions[optionPosition - 1] = optionValue
    const selectedVariant = this.productJson.variants.find(
      variant => variant.options.join('') === currentOptions.join('')
    )
    this.resetButtons()
    this.selectedVariantJson = selectedVariant
    this.updateOptionsUI()
    this.updatePriceUI()
    this.resetQuantity()
  }

  handleSelectChange(select) {
    const optionValue = select.value
    const optionPosition = parseInt(select.dataset.optionPosition, 10)
    const currentOptions = [...this.selectedVariantJson.options]
    currentOptions[optionPosition - 1] = optionValue
    const selectedVariant = this.productJson.variants.find(
      variant => variant.options.join('') === currentOptions.join('')
    )
    this.resetButtons()
    this.selectedVariantJson = selectedVariant
    this.updateOptionsUI()
    this.updatePriceUI()
    this.resetQuantity()
  }

  handleQuantityChange(button) {
    const action = button.dataset.action
    const variantId = this.selectedVariantJson.id
    const currentQuantity = parseInt(this.quantities[variantId])
    const currentSelectedQuantity = parseFloat(this.quantityInput.value)

    if (action === 'decrease' && currentSelectedQuantity > 1) {
      this.quantityInput.value = currentSelectedQuantity - 1
    } 

    if (action === 'increase' && currentSelectedQuantity < currentQuantity) {
      this.quantityInput.value = currentSelectedQuantity + 1
    } 
  }

  async handleAddToCart() {
    this.toggleLoading(true)

    let formData = {
      items: [
        {
          id: this.selectedVariantJson.id,
          quantity: parseInt(this.quantityInput.value)
        }
      ]
    }

    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })

    if (res.status !== 200) {
      toast('Ce produit est en rupture de stock')
    } else {
      document.dispatchEvent(new Event('updateCart'))
      setTimeout(() => document.dispatchEvent(new Event('toggleCart')), 500)
    }

    this.toggleLoading(false)
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // console.log('selectedVariantJson ->', selectedVariantJson)
  // console.log('productJson ->', productJson)
  new PDP(productJson, selectedVariantJson)
})

